if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.tabsInit === 'true') return;
      this.dataset.tabsInit = 'true';

      this.tabs = this.querySelectorAll('.tabs-component__tab');
      this.contents = this.querySelectorAll('.tabs-component__content');

      if (!this.tabs.length || !this.contents.length) return;

      this.addEventListener('click', this.handleClick.bind(this));
      this.activateTab(this.tabs[0]);
    }

    handleClick(event) {
      const tab = event.target.closest('.tabs-component__tab');
      if (!tab || !this.contains(tab)) return;
      this.activateTab(tab);
    }

    activateTab(tab) {
      const tabId = tab.getAttribute('data-tab');
      if (!tabId) return;

      this.tabs.forEach((item) => item.classList.remove('active'));
      tab.classList.add('active');

      this.contents.forEach((content) => {
        const isActive = content.getAttribute('data-content') === tabId;
        content.classList.toggle('is-active', isActive);
        content.hidden = !isActive;
      });
    }
  }

  customElements.define('tabs-component', TabsComponent);
}
